export default __webpack_public_path__ + "static/media/hall.3a302380.png";